import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule} from "@angular/forms";
import {NewTicketComponent} from "./new-ticket.component";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatDividerModule} from "@angular/material/divider";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {MatTooltipModule} from "@angular/material/tooltip";
import {UsernameToNameModule} from "@app/pipes/username-to-name/username-to-name.module";

@NgModule({
    declarations: [NewTicketComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        FormsModule,
        MatSelectModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatDividerModule,
        LogPipeModule,
        MatTooltipModule,
        UsernameToNameModule
    ],
    exports: [NewTicketComponent]
})
export class NewTicketModule { }
